// Checkbox with a label and a muted explanation underneath, used for the options and second confirmations of the job dialogs.
import { useId, type ReactNode } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";

interface CheckboxFieldProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: ReactNode;
  description?: ReactNode;
  disabled?: boolean;
}

export function CheckboxField({
  checked,
  onCheckedChange,
  label,
  description,
  disabled = false,
}: CheckboxFieldProps) {
  const id = useId();
  const descriptionId = useId();
  return (
    <div className="flex items-start gap-2.5">
      <Checkbox
        id={id}
        checked={checked}
        disabled={disabled}
        aria-describedby={description === undefined ? undefined : descriptionId}
        onCheckedChange={(value) => {
          onCheckedChange(value === true);
        }}
        className="mt-0.5"
      />
      <div className="min-w-0">
        <Label htmlFor={id} className="text-ui text-foreground">
          {label}
        </Label>
        {description === undefined ? null : (
          <p id={descriptionId} className="m-0 mt-0.5 text-chip text-muted-foreground">
            {description}
          </p>
        )}
      </div>
    </div>
  );
}
